import React from 'react';
import {NavLink} from 'react-router-dom';
import {
    getClosest,
    getSiblings,
    slideToggle,
    slideUp,
} from "../../../utils";

const MobileNavMenu = () => {
    const onClickHandler = (e) => {
        const target = e.currentTarget;
        const parentEl = target.parentElement;
        if (
            parentEl?.classList.contains("menu-toggle") ||
            target.classList.contains("menu-toggle")
        ) {
            const element = target.classList.contains("icon")
                ? parentEl
                : target;
            const parent = getClosest(element, "li");
            const childNodes = parent.childNodes;
            const parentSiblings = getSiblings(parent);
            parentSiblings.forEach((sibling) => {
                const sibChildNodes = sibling.childNodes;
                sibChildNodes.forEach((child) => {
                    if (child.nodeName === "UL") {
                        slideUp(child, 1000);
                    }
                });
            });
            childNodes.forEach((child) => {
                if (child.nodeName === "UL") {
                    slideToggle(child, 1000);
                }
            });
        }
    };
    return (
        <nav className="site-mobile-menu">
    <ul>
        <li>
            <NavLink to={process.env.PUBLIC_URL + "/"}><span className="menu-text text-dark">Home</span></NavLink>
        </li>
        <li>
            <NavLink to={process.env.PUBLIC_URL + "/about"}><span className="menu-text text-dark">About Us</span></NavLink>
        </li>
        <li className="has-children">
            <NavLink to={process.env.PUBLIC_URL + ""}><span className="menu-text text-dark">Solutions</span></NavLink>
            <span className="menu-toggle" onClick={onClickHandler}><i className="icon fa fa-angle-down text-dark"></i></span>
            <ul className="sub-menu">
                <li><NavLink to={process.env.PUBLIC_URL + "/ABMPlatforms"}><span className="menu-text text-dark">ABM Platforms</span></NavLink></li>
                <li><NavLink to={process.env.PUBLIC_URL + "/Marketplaces"}><span className="menu-text text-dark">Marketplaces</span></NavLink></li>
                <li><NavLink to={process.env.PUBLIC_URL + "/AccountManager"}><span className="menu-text text-dark">Account Manager/ Customer Success Managers</span></NavLink></li>
                <li><NavLink to={process.env.PUBLIC_URL + "/Publishers"}><span className="menu-text text-dark">Publishers</span></NavLink></li>
                <li><NavLink to={process.env.PUBLIC_URL + "/PartnerManagers"}><span className="menu-text text-dark">Partner Managers</span></NavLink></li>
            </ul>
        </li>
         <li>
            <NavLink to={process.env.PUBLIC_URL + "/service"}><span className="menu-text text-dark">Services</span></NavLink>
        </li>
        <li>
            <NavLink to={process.env.PUBLIC_URL + "/work"}><span className="menu-text text-dark">Blog</span></NavLink>
        </li>
        <li>
            <NavLink to={process.env.PUBLIC_URL + "/contact"}><span className="menu-text text-dark">Contact Us</span></NavLink>
        </li>
    </ul>
</nav>
    )
}

export default MobileNavMenu;
